// extracted by mini-css-extract-plugin
export default {"cls1":"LdFqjJtnRs0vyond37Gq","cls2":"UsouIzCUBhD1EtwWeVqm LdFqjJtnRs0vyond37Gq"};